export default __webpack_public_path__ + "static/media/circle-up-blue-icon.6502e2a8.svg";